import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import { constructFrom } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';

const BASE_URL = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const isDesktopScreen = () => window.innerWidth >= 1024;
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "..."); // append dots
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};


const local = "https://localhost:44351/api/home/odisha"
const online = "https://api.shabdtoday.com/api/home/odisha"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"


const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};


function Odisha2() {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);

      if (response.data && response.data.mpNews.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response.data.mpNews.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };


  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);


  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };

  const generateShareLinks = (mainKhabarId, newsHeading) => {
    const encodedNewsHeading = encodeURIComponent(newsHeading);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <Helmet>
        <title>ओडिशा की ताज़ा समाचार | आज का नवीनतम ओडिशा समाचार हिंदी में | स्थानीय खबरें – शब्द टुडे</title>

        <meta name="title" content="ओडिशा की ताज़ा समाचार | आज का नवीनतम ओडिशा समाचार हिंदी में | स्थानीय खबरें – शब्द टुडे" />
        <meta
          name="description"
          content="ओडिशा के आज के ताज़ा समाचार हिंदी में पढ़ें। राजनीति, खेल, मनोरंजन, तकनीकी और स्थानीय घटनाओं से जुड़ी नवीनतम खबरें शब्द टुडे पर तुरंत प्राप्त करें।"
        />
        <meta name="keywords" content="ओडिशा समाचार, ओडिशा ताज़ा खबरें, ओडिशा आज की खबरें, ओडिशा स्थानीय समाचार, ओडिशा हिंदी समाचार, ओडिशा राजनीति समाचार, ओडिशा खेल समाचार, ओडिशा तकनीकी समाचार, ओडिशा मनोरंजन समाचार, ओडिशा ब्रेकिंग न्यूज़, ओडिशा प्रमुख खबरें" />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />

        <link rel="canonical" href="https://shabdtoday.com/odisha-news" />

        <meta property="og:title" content="ओडिशा की ताज़ा समाचार | आज का नवीनतम ओडिशा समाचार हिंदी में | स्थानीय खबरें – शब्द टुडे" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/odisha-news" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "मुख्य पृष्ठ", "item": "https://shabdtoday.com/" },
              { "@type": "ListItem", "position": 2, "name": "ओडिशा समाचार", "item": "https://shabdtoday.com/odisha-news" }
            ]
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://shabdtoday.com/odisha-news#webpage",
            "url": "https://shabdtoday.com/odisha-news",
            "name": "आज की ओडिशा की ताज़ा खबरें हिंदी में",
            "headline": "ओडिशा न्यूज़ – आज की ताज़ा खबरें हिंदी में",
            "description": "ओडिशा की राजनीति, खेल, मनोरंजन, मौसम, चक्रवात, भुवनेश्वर अपडेट और स्थानीय ताज़ा समाचार हिंदी में।",
            "image": "https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp",
            "inLanguage": "hi-IN",
            "isPartOf": {
              "@type": "WebSite",
              "@id": "https://shabdtoday.com/#website",
              "url": "https://shabdtoday.com/",
              "name": "शब्द टुडे",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://shabdtoday.com/?s={search_term}",
                "query-input": "required name=search_term"
              },
              "publisher": {
                "@type": "Organization",
                "name": "शब्द टुडे",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://shabdtoday.com/design/images/logo-s.webp"
                }
              }
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "मुख्य पृष्ठ", "item": "https://shabdtoday.com/" },
                { "@type": "ListItem", "position": 2, "name": "ओडिशा समाचार", "item": "https://shabdtoday.com/odisha-news" }
              ]
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://shabdtoday.com/odisha-news"
            },
            "url": "https://shabdtoday.com/odisha-news",
            "headline": "आज की ओडिशा की ताज़ा खबरें हिंदी में",
            "description": "ओडिशा की राजनीति, खेल, मनोरंजन, मौसम, चक्रवात, भुवनेश्वर अपडेट और स्थानीय ताज़ा समाचार हिंदी में।",
            "image": "https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp",
            "datePublished": new Date().toISOString().split('T')[0],
            "dateModified": new Date().toISOString().split('T')[0],
            "author": { "@type": "Organization", "name": "शब्द टुडे" },
            "publisher": {
              "@type": "Organization",
              "name": "शब्द टुडे",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            },
            "inLanguage": "hi-IN"
          })}
        </script>


      </Helmet>
      {/* <h1 className="visually-hidden">मध्यप्रदेश की ताज़ा खबरें</h1>
      <h2 className="visually-hidden">एमपी के प्रमुख समाचार</h2>
      <h3 className="visually-hidden">राजनीति | मौसम | प्रशासन | घटनाएं</h3> */}
      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;
                      return (
                        <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">

                              <div className="ak-module-details">
                                <h2 className="ak-module-title mb-2">
                                  <Link
                                    to={`/News-Details/${post.slug}`}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent default navigation
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    }}
                                    rel="bookmark"
                                    aria-label="Shabd Today"
                                    title={stripHtmlTags(post.newsTag)}
                                  >
                                    <span
                                      className="responsive-font"
                                      style={{ lineHeight: "30px" }}
                                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                                    />
                                  </Link>
                                </h2>
                                {/* <span className="tm-stmp"><FontAwesomeIcon icon={faClock} style={{ color: "crimson", fontSize: "12px" }} /><span>
                                  {getTimeAgoInHindi(post.date)}</span></span><br></br> */}
                              </div>

                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                  aria-label="Shabd Today"
                                  title={stripHtmlTags(post.newsHeading, 150)}
                                >


                                  <div className="ak-featured-thumb size-500">
                                    <img
                                      src={BASE_URL + post.newsImage}
                                      alt={stripHtmlTags(post.slug, 100)}
                                      width={410}
                                      height={180}
                                      loading="lazy"
                                    />
                                  </div>

                                </Link>
                              </div>
                              <div className="ak-module-terms badge">
                              </div>
                            </div>
                          </div>

                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  )
}

export default Odisha2
